module.exports = __webpack_public_path__ + "img/bg_plaza.767978a0.jpg";